import { Locale, defaultLocale, locales } from "./config";

export const LOCALE_COOKIE_NAME = "NEXT_LOCALE";
const COOKIE_MAX_AGE = 365 * 24 * 60 * 60; // 1 year in seconds

/**
 * Read locale from cookie (client-side only).
 * Returns defaultLocale if cookie is missing or invalid.
 */
export function getLocaleFromCookie(): Locale {
  if (typeof document === "undefined") return defaultLocale;

  const match = document.cookie
    .split("; ")
    .find((row) => row.startsWith(`${LOCALE_COOKIE_NAME}=`));

  if (!match) return defaultLocale;

  const value = match.split("=")[1] as Locale;
  return locales.includes(value) ? value : defaultLocale;
}

/**
 * Set locale cookie and update document lang attribute.
 */
export function setLocaleCookie(locale: Locale): void {
  if (typeof document === "undefined") return;

  document.cookie = `${LOCALE_COOKIE_NAME}=${locale}; path=/; max-age=${COOKIE_MAX_AGE}; SameSite=Lax`;
  document.documentElement.lang = locale;
}
